import { render, staticRenderFns } from "./ShopHome.vue?vue&type=template&id=becea2ee&scoped=true"
import script from "./ShopHome.vue?vue&type=script&lang=js"
export * from "./ShopHome.vue?vue&type=script&lang=js"
import style0 from "./ShopHome.vue?vue&type=style&index=0&id=becea2ee&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becea2ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('becea2ee')) {
      api.createRecord('becea2ee', component.options)
    } else {
      api.reload('becea2ee', component.options)
    }
    module.hot.accept("./ShopHome.vue?vue&type=template&id=becea2ee&scoped=true", function () {
      api.rerender('becea2ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/ShopHome.vue"
export default component.exports